var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHygieneIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14C13.2 14 11 11.8 11 9C11 5.7 14.9 1.7 15.3 1.3C15.7 0.9 16.3 0.9 16.7 1.3C17.1 1.7 21 5.7 21 9C21 11.8 18.8 14 16 14Z",
    fill: "#FDA94A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9 16.5C29.7 16.2 29.4 16 29 16C26.8 16 24.7 17 23.4 18.8L22.5 20C21.4 21.3 19.7 22 18 22H15C14.4 22 14 21.6 14 21C14 20.4 14.4 20 15 20H16.9C18.5 20 20 18.7 20 17.1V17C20 16.5 19.5 16 19 16H12.9C9.30001 16 6.40001 17.6 4.80001 20.2L2.10001 24.4C1.90001 24.7 1.90001 25.1 2.10001 25.4L5.10001 30.4C5.20001 30.6 5.50001 30.8 5.70001 30.9C5.80001 30.9 5.80001 30.9 5.90001 30.9C6.10001 30.9 6.30001 30.8 6.50001 30.7C10.3 28.2 14.7 26.9 19.2 26.9C22.5 26.9 25.5 25.1 27.1 22.2L29.8 17.4C30 17.2 30 16.8 29.9 16.5Z",
    fill: "#FDA94A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHygieneIconOrange);
export default __webpack_public_path__ + "static/media/hygiene-icon-orange.0b6975ab960c8ad420d0c93caf8742d7.svg";
export { ForwardRef as ReactComponent };